module.exports = __webpack_public_path__ + "static/media/tipton.8168bf35.jpg";